<template>
  <SocialMentionCard
    v-bind="{ ...$props, ...$attrs }"
    class="pointer"
    :icon="socialIcon(mention.type)"
    :list-title="listTitle"
    @click="$emit('click', $event)"
    @mention-removed="removeMention"
    @mention-selected="$emit('mention-selected', $event)"
  >
    <template #header>
      <span>
        <strong>
          r/{{ mention.source_name }}
          <strong> · </strong>
          <span class="text-help-text text-blue-grey">
            {{ $t("global.posted_by") }}
          </span>
        </strong>

        <span class="text-blue-grey">
          <span class="text-help-text block">
            u/{{ mention.author }}

            <TimeAgo
              class="self-start"
              :date="mention.timestamp"
            />
          </span>
        </span>
      </span>
    </template>

    <template #afterExcerpts>
      <div
        v-if="mention.reddit_post"
        class="q-my-md reddit-post-card"
      >
        <SocialMentionCardRedditPost
          hide-border-color
          :hide-engagement="options.engagementDisabled"
          :mention="mention.reddit_post"
          :stream="stream"
        />
      </div>
    </template>

    <slot />

    <template #engagement-items>
      <SocialMentionEngagementItem
        icon="updownvote"
        :model-value="mention.score"
      />

      <SocialMentionEngagementItem
        icon="comments"
        :model-value="mention.comments_count"
      />
    </template>
  </SocialMentionCard>
</template>

<script>
import { propsExcept, SocialMentionCard } from "shared/components/MentionCard";
import SocialMentionCardRedditPost from "shared/components/SocialMentionCardRedditPost.vue";
import SocialMentionEngagementItem from "shared/components/SocialMentionEngagementItem.vue";
import { socialIcon } from "shared/helpers/media";

export default {
  name: "SocialMentionCardRedditPostComment",
  components: {
    SocialMentionCard,
    SocialMentionCardRedditPost,
    SocialMentionEngagementItem,
  },
  props: {
    ...propsExcept(["listTitle"]),
  },
  emits: ["click", "mention-selected", "mention-removed"],
  computed: {
    listTitle() {
      return `u/${this.mention.author}`;
    },
  },
  methods: {
    socialIcon,
    removeMention(mention) {
      this.$emit("mention-removed", mention);
    },
  },
};
</script>

<style lang="scss" scoped>
.social-icon {
  &.ion-checkmark-circle {
    color: rgb(73 208 103 / 50%);
  }

  &.ion-close-circle {
    color: rgb(249 88 88 / 50%);
  }

  &.ion-remove-circle {
    color: rgb(50 159 236 / 50%);
  }
}

.social-verified {
  vertical-align: 0;
  margin-left: 3px;
}

.reddit-post-card {
  border-radius: 4px;
}
</style>
